import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { Img } from "../../sharedComponents/Images";
import { RCL } from "../RCL";
import * as styles from "./SeatMap.module.scss";

const SeatMap = ({ title, image, seatDescriptions }) => (
	<div className={cx(styles.seatMapContainer)}>
		{title && <h2 className={cx(styles.seatMapContainerTitle)}>{title}</h2>}

		<div className={cx(styles.seatMap)}>
			{seatDescriptions && (
				<div className={cx(styles.seatMapDescriptions)}>
					{seatDescriptions.map(description => (
						<div key={description.title && description.title} className={cx(styles.description)}>
							{description.image && (
								<div>
									<Img src={description.image} alt={description.title && description.title} />
								</div>
							)}
							<div className={cx(styles.descriptionDetails)}>
								{description.title && <strong>{description.title}</strong>}
								{description.pitch && <span>{description.pitch}</span>}
								{description.price && <span>{description.price}</span>}
							</div>
						</div>
					))}
				</div>
			)}

			{image && (
				// eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
				<div className={cx(styles.seatMapPlane)} tabIndex="0">
					<Img src={image} alt={RCL({ searchKey: "seat-map" })} />
				</div>
			)}
		</div>
	</div>
);

SeatMap.propTypes = {
	title: PropTypes.string,
	image: PropTypes.string,
	seatDescriptions: PropTypes.arrayOf(
		PropTypes.shape({
			title: PropTypes.string,
			pitch: PropTypes.string,
			price: PropTypes.string,
			image: PropTypes.string,
		})
	),
};
SeatMap.defaultProps = {
	title: null,
	image: null,
	seatDescriptions: [],
};

export default SeatMap;
export { SeatMap };
